<template>
  <div>
    <GlobalInfoBar title="批量激活导入" subtitle="导入激活表，与系统待生效设备做串号匹配后批量激活，已激活和已失效设备不受影响" />

    <GlobalChunk title="导入说明" :padding="[20, 20, 20, 20]">
      <div class="annotation-box">
        1. 支持 .xlsx / .xls / .csv 格式文件上传<br />
        2. 文件必须包含字段：IMEI号、激活时间<br />
        3. 仅匹配「待生效」状态设备，已激活 / 已失效设备不受影响<br />
        4. 缺少激活时间的记录标记为失败并跳过；匹配成功的设备自动标记为「已激活」<br />
        5. 绑定险种由导入表中的产品编码自动识别，确认后该批设备绑定对应保险
      </div>
      <el-upload
        class="upload-zone"
        drag
        action="#"
        :auto-upload="false"
        :show-file-list="false"
        accept=".xlsx,.xls,.csv"
        :on-change="handleFile"
        :disabled="uploadLoading"
      >
        <i class="el-icon-success" style="font-size: 32px; color: #80C269"></i>
        <div style="font-size: 14px; color: #555; margin-top: 12px">点击或拖拽文件到此处上传</div>
        <div style="font-size: 12px; color: #999; margin-top: 6px">支持 xlsx、xls、csv 格式，单次最大 10MB</div>
        <el-button type="success" size="small" style="margin-top: 14px" :loading="uploadLoading">选择文件</el-button>
      </el-upload>
    </GlobalChunk>

    <GlobalChunk title="导入历史" :padding="[20, 20, 20, 20]" style="margin-top: 20px">
      <GlobalTable
        ref="GlobalTable"
        :columns="tableColumns"
        :data="tableData"
        v-loading="historyLoading"
        :isIndex="false"
        :isPagination="true"
        :currentPage="curPage"
        :total="total"
        :pageSize="pageSize"
        @handleCurrentChange="currentChange"
      >
        <el-table-column slot="success" label="成功" align="center">
          <template slot-scope="{ row }"><span style="color: #67c23a; font-weight: bold">{{ row.success_num }}</span></template>
        </el-table-column>
        <el-table-column slot="fail" label="失败" align="center">
          <template slot-scope="{ row }"><span :style="row.fail_num > 0 ? 'color:#f56c6c;font-weight:bold;' : ''">{{ row.fail_num }}</span></template>
        </el-table-column>
        <el-table-column slot="action" label="操作" align="center" width="120">
          <template slot-scope="{ row }"><el-button size="mini" @click="downloadResult(row)">下载结果</el-button></template>
        </el-table-column>
      </GlobalTable>
      <!-- <div class="history-note">点击「下载结果」导出原始上传表格内容，并在原表基础上增加一列「失败原因」，逐行注明未处理原因（未匹配 / 匹配但已激活 / 匹配但已失效 / 缺少激活时间等）。</div> -->
    </GlobalChunk>
  </div>
</template>

<script>
import _api from '@/utils/request'

export default {
  name: '批量激活导入',
  data() {
    return {
      tableColumns: [
        { prop: 'add_time', label: '导入时间' },
        { prop: 'title', label: '文件名' },
        { prop: 'total_num', label: '总条数' },
        { slotName: 'success' },
        { slotName: 'fail' },
        { prop: 'user_name', label: '操作人' },
        { slotName: 'action' }
      ],
      tableData: [],
      curPage: 1,
      total: 0,
      pageSize: 10,
      uploadLoading: false,
      historyLoading: false
    }
  },
  created() {
    this.fetchHistory();
  },
  methods: {
    currentChange(page) {
      this.curPage = page
      this.fetchHistory()
    },
    fetchHistory() {
      this.historyLoading = true
      _api.importHistory({ page: this.curPage, limit: this.pageSize, model: 2 })
        .then((res) => {
          const payload = (res && res.data) || {}
          const rows = Array.isArray(payload) ? payload : (payload.data || payload.list || [])
          this.tableData = rows.map((row) => ({
            ...row,
            add_time: row.add_time || row.create_time || row.operate_time || row.operation_time,
            title: row.title || row.file_name || row.filename || row.name,
            total_num: row.total_num !== undefined ? row.total_num : row.total,
            success_num: row.success_num !== undefined ? row.success_num : row.success,
            fail_num: row.fail_num !== undefined ? row.fail_num : row.fail,
            user_name: row.user_name || row.operator_name || row.operator || row.username,
            file_url: row.file_url || row.download_url || row.url
          }))
          this.total = Number(res && (res.count !== undefined ? res.count : (res.total !== undefined ? res.total : payload.count))) || 0
        })
        .catch(() => { this.tableData = []; this.total = 0 })
        .finally(() => { this.historyLoading = false })
    },
    handleFile(file) {
      if (!file || !file.raw || this.uploadLoading) return
      this.uploadLoading = true
      const formData = new FormData()
      formData.append('file', file.raw)
      _api.batchActivateImport(formData).then(res => {
        this.$message({ type: 'success', message: (res && res.msg) || '文件上传成功' })
        this.curPage = 1
        this.fetchHistory()
      }).catch(() => {
        this.$message({ type: 'error', message: '文件上传失败，请稍后重试' })
      }).finally(() => {
        this.uploadLoading = false
      })
    },
    downloadResult(row) {
      const id = row.id || row.log_id || row.import_id
      if (!id) {
        this.$message({ type: 'info', message: '暂无下载记录' })
        return
      }
      _api.importResultDownload({ id, log_id: id }).then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = row.title || '批量激活导入结果.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)
      }).catch(() => this.$message({ type: 'error', message: '下载结果失败' }))
    }
  }
}
</script>

<style scoped lang="scss">
.annotation-box {
  background: #eaf6f2;
  border-left: 4px solid #087f5b;
  padding: 12px 16px;
  border-radius: 0 8px 8px 0;
  margin: 12px 0 16px;
  font-size: 12px;
  color: #316b59;
  line-height: 1.8;
}

.upload-zone {
  ::v-deep .el-upload-dragger {
    width: 100%;
    padding: 20px;
    border-radius: 12px;
    border: 2px dashed #d9d9d9;
    height: auto;

    &:hover,
    &.is-dragover {
      border-color: #52c41a;
    }
  }
}

.history-note {
  margin-top: 14px;
  color: #087f5b;
  background: #eaf6f2;
  border-left: 4px solid #087f5b;
  padding: 12px 16px;
  font-size: 12px;
  line-height: 1.7;
}
</style>
